import MerchantSummaryReportView from './MerchantSummaryReportView';

export default MerchantSummaryReportView;
